var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-group"},[_c('div',{staticClass:"item text-center"},[_c('h2',[_vm._v("Published Projects")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.publishedPorjects))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('h2',[_vm._v("Total Participant Count")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.totalParticipantCount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }